/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.campaignsbucket.rpc.CampaignsBucketServiceFrontendRpc
 */
import * as References from './CampaignsBucketServiceFrontendRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaignsbucket.rpc.CampaignsBucketServiceFrontendRpc#resolveBuckets
 */
export const RESOLVE_BUCKETS_QUERY_FIELD_NAME = 'com_hubspot_campaignsbucket_rpc_CampaignsBucketServiceFrontendRpc_resolveBuckets';
export const RESOLVE_BUCKETS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RESOLVE_BUCKETS_QUERY_FIELD_NAME,
  args: ['requests'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.resolveBucketsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaignsbucket.rpc.CampaignsBucketServiceFrontendRpc#resolveBucketsByAssetCoordinates
 */
export const RESOLVE_BUCKETS_BY_ASSET_COORDINATES_QUERY_FIELD_NAME = 'com_hubspot_campaignsbucket_rpc_CampaignsBucketServiceFrontendRpc_resolveBucketsByAssetCoordinates';
export const RESOLVE_BUCKETS_BY_ASSET_COORDINATES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RESOLVE_BUCKETS_BY_ASSET_COORDINATES_QUERY_FIELD_NAME,
  args: ['coordinates'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.resolveBucketsByAssetCoordinatesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaignsbucket.rpc.CampaignsBucketServiceFrontendRpc#resolveBucketsWithUtm
 */
export const RESOLVE_BUCKETS_WITH_UTM_QUERY_FIELD_NAME = 'com_hubspot_campaignsbucket_rpc_CampaignsBucketServiceFrontendRpc_resolveBucketsWithUtm';
export const RESOLVE_BUCKETS_WITH_UTM_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RESOLVE_BUCKETS_WITH_UTM_QUERY_FIELD_NAME,
  args: ['requests'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.resolveBucketsWithUtmRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.campaignsbucket.rpc.CampaignsBucketServiceFrontendRpc#resolveBucketsWithUtmByAssetCoordinates
 */
export const RESOLVE_BUCKETS_WITH_UTM_BY_ASSET_COORDINATES_QUERY_FIELD_NAME = 'com_hubspot_campaignsbucket_rpc_CampaignsBucketServiceFrontendRpc_resolveBucketsWithUtmByAssetCoordinates';
export const RESOLVE_BUCKETS_WITH_UTM_BY_ASSET_COORDINATES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RESOLVE_BUCKETS_WITH_UTM_BY_ASSET_COORDINATES_QUERY_FIELD_NAME,
  args: ['coordinates'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.resolveBucketsWithUtmByAssetCoordinatesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});